const UnitsMeasurement = {
  'units of measurement': 'Unidades de Medidas'
};

export default UnitsMeasurement;
